import useId from '../utils/useId';
import * as React from 'react';
export const AESvg = React.forwardRef(function AESvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `fi_FlagIcon-AE__b_${id_0}`,
          width: '108.3%',
          height: '125%',
          x: '-4.2%',
          y: '-12.5%',
          filterUnits: 'objectBoundingBox',
        },
        /*#__PURE__*/ React.createElement('feOffset', {
          dx: -1,
          in: 'SourceAlpha',
          result: 'shadowOffsetInner1',
        }),
        /*#__PURE__*/ React.createElement('feComposite', {
          in: 'shadowOffsetInner1',
          in2: 'SourceAlpha',
          k2: -1,
          k3: 1,
          operator: 'arithmetic',
          result: 'shadowInnerInner1',
        }),
        /*#__PURE__*/ React.createElement('feColorMatrix', {
          in: 'shadowInnerInner1',
          values:
            '0 0 0 0 0.917647059 0 0 0 0 0.933333333 0 0 0 0 0.952941176 0 0 0 1 0',
        }),
      ),
      /*#__PURE__*/ React.createElement('path', {
        id: `fi_FlagIcon-AE__a_${id_1}`,
        d: 'M4 4h12v4H4z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 0C.895 0 0 .902 0 2.009V9.99A2 2 0 0 0 2 12h2V0H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M4 0v4h12V2c0-1.105-.902-2-2.009-2H4Z',
      }),
      /*#__PURE__*/ React.createElement('use', {
        fill: '#F6F9FC',
        xlinkHref: '#fi_FlagIcon-AE__a',
      }),
      /*#__PURE__*/ React.createElement('use', {
        fill: '#000',
        filter: `url(#fi_FlagIcon-AE__b_${id_0})`,
        xlinkHref: '#fi_FlagIcon-AE__a',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M4 8v4h9.991A2 2 0 0 0 16 10V8H4Z',
      }),
    ),
  );
});
AESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var AE = {
  category: 'flag',
  colorable: false,
  name: 'AE',
  svg: AESvg,
};
